module.exports = __webpack_public_path__ + "static/twitter-a70229d2f03fd23ef05603ecd1741a82.png";